import { render, staticRenderFns } from "./SelectTaxi.vue?vue&type=template&id=11fe7f0f&"
import script from "./SelectTaxi.vue?vue&type=script&lang=js&"
export * from "./SelectTaxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports